import { defineStore, getActivePinia } from 'pinia'

import type { GaApp } from '~/modules/app'

import { state } from './state'

export const sourcesStore = (gaApp: GaApp) => {
  const init = defineStore('sources', {
    state,
  })

  return init(getActivePinia())
}
